import { InfoCircleTwoTone } from "@ant-design/icons"
import { Tooltip } from "antd"

const BudgetChangeInfo = () => {
  return <Tooltip title="Changing the MORS Budget affects new items added to the job, but not existing items. Existing items can be manually synced to the updated budget.">
    <InfoCircleTwoTone />
  </Tooltip>
}
export default BudgetChangeInfo
